import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.627-4.209a6.19 6.19 0 0 1-6.33-1.494l-2.594-2.594a6.19 6.19 0 0 1-1.494-6.33 1.546 1.546 0 0 1 2.56-.604l.981.981c.69.69.69 1.81 0 2.5s-.69 1.81 0 2.5l1.5 1.5c.69.69 1.81.69 2.5 0s1.81-.69 2.5 0l.98.98a1.546 1.546 0 0 1-.604 2.561",
      clipRule: "evenodd"
    }
  )
);
var SvgCallCircleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallCircleFilled_default = SvgCallCircleFilled;

export { CallCircleFilled_default as default };
